export default __webpack_public_path__ + "static/media/Comptes_Modifier.11c6866e.png";